export enum OsasPapType {
    apap = 'APAP',
    biPap = 'BiPAP',
    cpap = 'CPAP',
}
